<ng-container *ngIf="showFeatured && featuredArticle">
  <div class="bg-white rounded-10 custom-shadow overflow-hidden free-picks-blog article-details mb-4"
    *ngIf="featuredArticle.image as image">
    <div class="free-picks-heading px-3 py-2 text-dark">
      <a [routerLink]="[
                    '/',
                    featuredArticle.category?.toLowerCase(),
                    'articles',
                    featuredArticle.slug
                  ]" class="text-decoration-none d-block">
        <h1 class="fw-bold mb-0 border-start border-primary ps-2">{{ featuredArticle.title }}</h1>
      </a>
    </div>
    <ul class="list-inline px-3 mb-0 align-self-end col-12 px-0">
      <li class="list-inline-item">
        <a [routerLink]="[
            '/',
            featuredArticle | UserSlug,
            'profile',
            'statistics'
          ]" class="text-decoration-none d-block">
          <div class="sidebar-user-img border rounded-circle border-light">
            <img [src]="featuredArticle.user_avatar" alt="user" class="img-fluid shadow-sm" width="30" />
          </div>
        </a>
      </li>
      <li class="list-inline-item">
        <a [routerLink]="[
            '/',
            featuredArticle | UserSlug,
            'profile',
            'statistics'
          ]" class="text-decoration-none">
          <div class="free-picks-user-name fw-bold">
            {{ featuredArticle.name }}
          </div>
        </a>
      </li>
      <li class="list-inline-item" *ngIf="_common.isBrowser">
        <small class="text-muted"><i class="far fa-dot-circle small text-dark"></i>
          {{ featuredArticle.created_at | duration | async }}</small>
      </li>
    </ul>
    <div class="top-winner-list-item-img position-relative p-1">
      <img [src]="image" [alt]="featuredArticle.title" class="img-fluid rounded-10" />
    </div>
  </div>
</ng-container>
<ng-container *ngIf="articles?.length">
  <!-- <div class="side-table-view-heading p-3 bg-blue-gradient text-white">
    Relevant Articles and Videos
  </div> -->
  <div class="overflow-hidden mb-4">
    <div class="side-table-view-heading p-3 bg-blue-gradient text-white mb-3 rounded-10">
      Relevant Articles and Videos
    </div>
    <div class="row">
      <ng-container *ngFor="let article of articles">
        <div class="col mb-4">
          <div
            class="pb-3 d-flex row mx-0 rounded-10 bg-white custom-shadow overflow-hidden top-winner-list-colunm h-100">
            <a [routerLink]="[
                '/',
                article.category?.toLowerCase(),
                'articles',
                article.slug
              ]" routerLinkActive="router-link-active" class="col-12 px-0">
              <div class="top-winner-list-item article-image">
                <img [src]="article.image" [alt]="article.title" class="img-fluid" />
              </div>
              <div class="sidebsr-article-details">
                <a [routerLink]="[
                    '/',
                    article.category?.toLowerCase(),
                    'articles',
                    article.slug
                  ]" class="text-decoration-none d-block">
                  <div class="free-picks-heading px-3 py-2 text-dark">
                    <h5 class="mb-0 border-start border-primary ps-2 block-ellipsis text-f14"
                      title="{{ article.title }}">
                      {{ article.title }}
                    </h5>
                  </div>
                </a>
              </div>
            </a>
            <ul class="list-inline px-3 mb-0 align-self-end col-12 px-0">
              <li class="list-inline-item">
                <a [routerLink]="[
                    '/',
                    article | UserSlug,
                    'profile',
                    'statistics'
                  ]" class="text-decoration-none d-block">
                  <div class="sidebar-user-img border rounded-circle border-light">
                    <img [src]="article.user_avatar" alt="user" class="img-fluid shadow-sm" width="30" />
                  </div>
                </a>
              </li>
              <li class="list-inline-item">
                <a [routerLink]="[
                    '/',
                    article | UserSlug,
                    'profile',
                    'statistics'
                  ]" class="text-decoration-none">
                  <div class="free-picks-user-name fw-bold">
                    {{ article.name }}
                  </div>
                </a>
              </li>
              <li class="list-inline-item" *ngIf="_common.isBrowser">
                <small class="text-muted"><i class="far fa-dot-circle small text-dark"></i>
                  {{ article.created_at | duration | async }}</small>
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
      <div class="text-end col-12">
        <a [routerLink]="['/',selectedSport?.toLowerCase() || '', 'free-picks', 'articles']"
          class="small text-decoration-none pointer-cursor">Load More</a>
      </div>
    </div>
  </div>
</ng-container>